/** @jsxImportSource @emotion/react */
import { IntlShape } from 'react-intl-next';
import { vatCodeName } from './messages';
import { VatCode} from './types';

type Props = {
  intl: IntlShape;
  vatCode?: VatCode;
};

const getVatCodeName = ({intl, vatCode}: Props) => {
  const vatCodeId = vatCode?.id;
  if(!vatCodeId) return null;
  if(vatCodeName[vatCodeId]) {
    return intl.formatMessage(vatCodeName[vatCodeId])
  }
  return vatCode?.displayName;
};

export default getVatCodeName;
